import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import useRole from '../../../hooks/useRole';

const HeaderAllFacture = () => {

    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const role=useRole();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    return (
        <>
            <div className='frame7TableMissionBDCAdmin'>
                <div className='frame8TableMissionBDCAdmin'>
                    <Button
                        className='frame29CvTheque'
                        onClick={() =>
                        {
                            if(role=='esn' && (currentPath=='AllRegularisationVente' || currentPath=='AllFacturesVente'))
                                navigate('/'+role+'/AllFacturesVente');
                            else
                                navigate('/'+role+'/AllFactures');
                        }}
                        style={
                            (currentPath=='AllFactures' || currentPath=='AllFacturesVente')?
                                {...buttonStyles(),...{background:'#E7EAF9',color:'#214DCE',borderRadius:'26px',width:'100px'}}
                                :
                                {...buttonStyles(),...{color:'#475063'}}
                        }
                    >
                        {i18n.t('Factures')}
                    </Button>

                    <Button
                        className='frame31CvTheque'
                        onClick={() =>
                        {
                            if(role=='esn' && (currentPath=='AllRegularisationVente' || currentPath=='AllFacturesVente'))
                                navigate('/'+role+'/AllRegularisationVente');
                            else
                                navigate('/'+role+'/AllRegularisation');
                        }}
                        //style={
                        //    currentPath!='AllFactures'  ?
                        //        selectedFrameCvTheque:
                        //        notSelectedFrameCvTheque
                        //}
                        style={
                            (currentPath!='AllFactures' && currentPath!='AllFacturesVente') ?
                                {...buttonStyles(),...{background:'#E7EAF9',color:'#214DCE',borderRadius:'26px',width:'135px'}}
                                :
                                {...buttonStyles(),...{color:'#475063'}}
                        }

                    >
                        {i18n.t('Régularisations')}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default HeaderAllFacture;